import _ from 'lodash';

const generateDeltaRandomId = () =>
  _.times(8, () => _.random(35).toString(36)).join('');

export default generateDeltaRandomId;
